import { createSelector } from "reselect";
import { primaryContextSelector } from "orion-components/ContextPanel/Selectors";
import isEmpty from "lodash/isEmpty";
import includes from "lodash/includes";
import groupBy from "lodash/groupBy";
import frameShapeAndIconGenerator from "orion-components/Map/Utils/FrameShapeAndIconGenerator";
import { canvasIconFrameOverlayGenerator } from "../Utils/CanvasIconFrameOverlayGenerator";
import { userFeedsSelector } from "orion-components/GlobalData/Selectors";

const contextualDataSelector = (state) => state?.contextualData ?? {};

const facilityIdSelector = (state) => primaryContextSelector(state);

export const floorPlanDevicesSelector = createSelector(
	[contextualDataSelector, facilityIdSelector],
	(contextualData, facilityId) => contextualData[facilityId]?.floorPlanDevices ?? []
);

const filtersSelector = (state, filters) => filters;
const mapSelector = (state) => state.mapState.baseMap?.mapRef;

export const filteredDeviceSelector = createSelector(
	[floorPlanDevicesSelector, filtersSelector],
	(devices, filters) => {
		if (!Object.values(devices).length) return {};
		return Object.keys(devices).reduce((acc, device) => {
			if (!filters || isEmpty(filters) || includes(filters, device)) {
				acc[device] = { ...devices[device] };
			}
			return acc;
		}, {});
	}
);

export const groupedFeatureDataSelector = createSelector(
	[filteredDeviceSelector, userFeedsSelector, mapSelector],
	(filteredDevice, userFeeds, map) => {
		if (!userFeeds) return {}; // Ensure userFeeds is available before processing

		return groupBy(
			Object.keys(filteredDevice).map((device) => {
				const feed = userFeeds.find((record) => record.feedId === filteredDevice[device].feedId);

				// Generate frame shape and icon for the device
				const { frame, icon } = frameShapeAndIconGenerator(
					filteredDevice[device].entityData,
					feed,
					filteredDevice[device].entityType
				);

				// Update entity properties with generated icon and frame shape
				if (frame !== null && icon !== null) {
					const mapCanvasIcon = `${icon}-${frame}`;
					filteredDevice[device].entityData.properties.mapIcon = mapCanvasIcon;
					canvasIconFrameOverlayGenerator(icon, frame, map);
				}

				return filteredDevice[device].entityData;
			}),
			"feedId"
		);
	}
);
